var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettlement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8D8599",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.867 4.464c.08-.222.121-.457.12-.694l-.12.694Zm-4.242 0-.12-.694c-.002.237.039.472.12.694ZM13.278 4.987c.132-.392.2-.803.202-1.217l-.202 1.217Zm-7.064 0L6.012 3.77c.002.414.07.825.202 1.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.973 12.731h-2.987l1.292-7.744.202-1.217a3.734 3.734 0 0 0-7.467 0l.201 1.217 1.292 7.744H4.519L.785 16.465v1.493h17.922v-1.493l-3.734-3.734Zm-5.227-11.2a2.24 2.24 0 0 1 2.24 2.24c.003.236-.038.471-.12.694a2.24 2.24 0 0 1-4.24 0 1.971 1.971 0 0 1-.12-.695 2.24 2.24 0 0 1 2.24-2.24Zm1.688 5.57-.941 5.63H8.999l-.94-5.63a3.734 3.734 0 0 0 3.375 0Zm-8.528 9.364 2.24-2.24h9.2l2.24 2.24H2.906Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z",
    transform: "translate(.749)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlement);
export default __webpack_public_path__ + "static/media/settlement.b1087e90.svg";
export { ForwardRef as ReactComponent };